import { Toaster } from 'sonner';
import { useState } from 'react';

import Navbar from 'components/Navbar';

import UserService from 'services/userService';

export default function AdminLayout({ children }) {
  const [currentUser] = useState(UserService.getCurrentUser());

  return (
    <div
      className="
      flex flex-col
      min-h-screen
      "
    >
      <Toaster richColors position="top-center" className="select-none" />
      <main className="flex-1">
        <Navbar currentUser={currentUser} />
        <div
          className="
          container mx-auto
          p-2 m-3 mt-12
          "
        >
          {children}
        </div>
      </main>
    </div>
  );
}
